import { getIntersectionSegmentIndex } from './getIntersectionCoord';
export const isSamePoint = (a, b) => {
    return a.every((xy, index) => xy === b[index]);
};
export const splitMultiLineStringInPoint = (intersectionPoint, multiLineString) => {
    const intersection = getIntersectionSegmentIndex(intersectionPoint, multiLineString);
    const splittedMultiLineStrings = [];
    let currentMultiLineString = [];
    multiLineString.forEach((lineString, lineStringIndex) => {
        let currentLineString = [];
        if (intersection.lineStringIndex === lineStringIndex) {
            lineString.forEach((point, lineStringSegmentIndex) => {
                if (intersection.lineStringSegmentIndex === lineStringSegmentIndex) {
                    // jsme na segmentu s prusecikem
                    currentLineString.push(point);
                    if (!isSamePoint(point, intersectionPoint)) {
                        currentLineString.push(intersectionPoint);
                    }
                    // ukoncuju
                    if (currentLineString.length > 1) {
                        currentMultiLineString.push(currentLineString);
                    }
                    currentLineString = [];
                    if (currentMultiLineString.length) {
                        splittedMultiLineStrings.push(currentMultiLineString);
                        currentMultiLineString = [];
                    }
                    currentLineString.push(intersectionPoint);
                }
                else {
                    if (!currentLineString.length ||
                        !isSamePoint(point, currentLineString[currentLineString.length - 1])) {
                        currentLineString.push(point);
                    }
                }
            });
        }
        else {
            currentLineString = lineString;
        }
        if (currentLineString.length > 1) {
            currentMultiLineString.push(currentLineString);
        }
    });
    if (currentMultiLineString.length) {
        splittedMultiLineStrings.push(currentMultiLineString);
    }
    return splittedMultiLineStrings;
};
//# sourceMappingURL=splitMultiLineStringInPoint.js.map